// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"56dea66d","786":"448b4112","965":"720afdb5"}[chunkId] + ".chunk.js";
};